import Tooltip from '@/components/Tooltip';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const NarrativeValuatorTooltip = ({ children }: Props) => {
  return (
    <Tooltip
      light
      title={
        <div className="max-w-[260px] px-x1_5 py-x1 text-center text-tiny text-p-grey-30">
          {children}
        </div>
      }
    >
      <button className="focus:outline-solid rounded-x0_5 focus:outline-dashed focus:outline-1 focus:outline-offset-[3px] focus:outline-p-blue-100">
        <InformationSolid className="fill-softer" />
      </button>
    </Tooltip>
  );
};
